module.exports = __webpack_public_path__ + "media/images/content/pic_direction_es-966e4874c8efc1bac6524287f5281a14.svg";